export default __webpack_public_path__ + "static/media/136-mark.c44dc687.svg";